import { ToastContainer } from 'react-toastify';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from './Footer';
import ProHeader from '../ProHeader';

const ProLayout = () => {
  const location = useLocation();
  const hideLayout = location.pathname.includes('registration');

  return (
    <>
      <ToastContainer className='mt-16' />
      {!hideLayout && <ProHeader />}
      <div className='flex min-h-screen flex-col justify-between'>
        <div className='grow'>
          <Outlet />
        </div>
        {!hideLayout && <Footer className='justify-self-end' />}
      </div>
    </>
  );
};

export default ProLayout;
